// Base Imports
import { useEffect } from 'react'
import { LayoutWithTopStrip } from '@components/common/Layout'
import { DATE_FORMAT, EmptyGuid } from '@components/utils/constants'
import commerce from '@lib/api/commerce'
import NextHead from 'next/head'

import { useRouter } from 'next/router'
import { formatDate } from '@components/utils/dateFormatter'
import { PagePropType, getPagePropType } from '@framework/page-props'
import { IPagePropsProvider } from '@framework/contracts/page-props/IPagePropsProvider'
import useEventAnalytics from '@components/services/analytics/useEventAnalytics'
import { AnalyticsEventType } from '@components/services/analytics'
import { useUI } from '@components/ui'
export default function BlogDetail({ blogData }: any) {
  const router = useRouter()
  const { cartItems } = useUI()
  const { recordAnalytics } = useEventAnalytics()
  useEffect(()=>{
    recordAnalytics(AnalyticsEventType.OTHER_PAGE, { type: 'other', data: { cartItems } })
  },[])
  return (
    <>
      {!blogData ? (
        <main className="bg-white fit">
          <div className="fixed top-0 right-0 z-50 flex items-center justify-center w-screen h-screen">
            <div className="w-32 h-32 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></div>
          </div>
        </main>
      ) : (
        <>
          {(blogData?.metatitle ||
            blogData?.metadescription ||
            blogData?.metakeywords) && (
            <>
              <NextHead>
                <meta
                  name="viewport"
                  content="width=device-width, initial-scale=1, maximum-scale=1"
                />
                <link
                  rel="canonical"
                  id="canonical"
                  href={
                    blogData?.canonical ||
                    'https://www.damensch.com' + router.asPath
                  }
                />
                {blogData?.metatitle && (
                  <>
                    <title>{blogData?.metatitle}</title>
                    <meta name="title" content={blogData?.metatitle} />
                  </>
                )}

                {blogData?.metadescription && (
                  <meta
                    name="description"
                    content={blogData?.metadescription}
                  />
                )}

                {blogData?.metakeywords && (
                  <meta name="keywords" content={blogData?.metakeywords} />
                )}
                <meta property="og:image" content={blogData?.image} />
                {blogData?.metatitle && (
                  <meta
                    property="og:title"
                    content={blogData?.metatitle}
                    key="ogtitle"
                  />
                )}
                {blogData?.metadescription && (
                  <meta
                    property="og:description"
                    content={blogData?.metadescription}
                    key="ogdesc"
                  />
                )}
              </NextHead>
            </>
          )}

          <div className="w-full">
            <div className="container px-4 mx-auto">
              {blogData?.blogheader?.length > 0 && (
                <>
                  {blogData?.blogheader?.map(
                    (detail: any, detailId: number) => (
                      <>
                        <div className="w-full py-8 text-center" key={detailId}>
                          <h1 className="text-2xl font-bold text-center text-black">
                            {detail?.blogheader_title}
                          </h1>
                        </div>
                        <div className="w-full main-image">
                          <div className="w-full text-center">
                            <img
                              placeholder="blur"
                              className="object-cover w-full rounded-lg"
                              src={detail?.blogheader_mainimage}
                              alt={detail?.blogheader_title}
                            />
                          </div>
                          <div className="w-full mt-2">
                            <p className="mb-6">
                              Published on{' '}
                              <b>
                                {formatDate(
                                  new Date(detail?.blogheader_publishedon),
                                  DATE_FORMAT
                                )}
                              </b>
                            </p>
                          </div>
                        </div>
                      </>
                    )
                  )}
                  <div
                    className="text-sm font-normal leading-7 text-primary dark:text-black blog-detail"
                    dangerouslySetInnerHTML={{
                      __html: blogData?.blogcontent || blogData?.blogcontent,
                    }}
                  />
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export async function getServerSideProps(context: any) {
  const slug = context?.query?.slug

  const blogUrl = slug?.length > 0 ? slug[0] : EmptyGuid
  const blogData = await commerce.getBlogDetail({
    query: `blog/${blogUrl}`,
  })
  const props: IPagePropsProvider = getPagePropType({ type: PagePropType.COMMON }) as IPagePropsProvider
  const commonPageProps = await props.getPageProps({ cookies: {} })
  return {
    props: {
      ...commonPageProps,
      blogUrl,
      blogData,
    },
  }
}

BlogDetail.Layout = LayoutWithTopStrip
